/**
 * Cart Recovery Channel Performance Component
 */
import { Bell, MessageSquare, Mail } from 'lucide-react';

export default function CartRecoveryChannels({ analytics }) {
  if (!analytics?.channel_performance) return null;

  const channels = [
    {
      key: 'push',
      label: 'Push Notifications',
      icon: Bell,
      bgColor: 'bg-blue-100 dark:bg-blue-900/30',
      iconColor: 'text-blue-600 dark:text-blue-400',
      data: analytics.channel_performance.push
    },
    {
      key: 'sms',
      label: 'SMS',
      icon: MessageSquare,
      bgColor: 'bg-green-100 dark:bg-green-900/30',
      iconColor: 'text-green-600 dark:text-green-400',
      data: analytics.channel_performance.sms
    },
    {
      key: 'email',
      label: 'Email',
      icon: Mail,
      bgColor: 'bg-purple-100 dark:bg-purple-900/30',
      iconColor: 'text-purple-600 dark:text-purple-400',
      data: analytics.channel_performance.email
    }
  ];

  return (
    <div className="bg-card rounded-xl p-6 border border-border" data-testid="channel-performance">
      <h3 className="text-lg font-semibold text-foreground mb-4">Channel Performance</h3>
      <div className="space-y-4">
        {channels.map(({ key, label, icon: Icon, bgColor, iconColor, data }) => (
          <div 
            key={key}
            className="flex items-center justify-between p-4 bg-muted/50 dark:bg-muted/30 rounded-lg"
          >
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-full ${bgColor} flex items-center justify-center`}>
                <Icon className={`w-5 h-5 ${iconColor}`} />
              </div>
              <div>
                <p className="font-medium text-foreground">{label}</p>
                <p className="text-sm text-muted-foreground">
                  {data?.sent || 0} sent
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-bold text-foreground">{data?.recovered || 0}</p>
              <p className="text-xs text-muted-foreground">recovered</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
